import React from 'react';
import { CLAIMANT_INFECTED_MESSAGE, REVIEWER_INFECTED_MESSAGE } from '../utils/scanStatus.mjs';

/**
 * Shown in place of a preview/download link when the background virus scan
 * flagged a file and the backend removed it.
 *
 * Claimants get the longer copy because they are the ones who can fix it (the
 * row's attach button still works). Reviewers only need to know the file is
 * gone and why, so they get the short label.
 *
 * Colours use the red-50/red-200/red-700 classes because index.css already
 * remaps those for dark mode.
 */
const InfectedFileNotice = ({ audience = 'claimant', className = '' }) => (
  <p
    role="status"
    className={`text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded px-2 py-1 ${className}`}
  >
    {audience === 'reviewer' ? REVIEWER_INFECTED_MESSAGE : CLAIMANT_INFECTED_MESSAGE}
  </p>
);

export default InfectedFileNotice;
